import React, { Component } from "react";
import { withUnits } from "../../../shared/containers/containerUnits";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { getCarsTypeName } from "../../sections/cars/static.carsTypes";
import styles from "./tripUnitsBar.module.scss";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import { withLogisticTrips } from "../../../shared/containers/containerLogisticTrips";
import { withAuth } from "../../../shared/containers/containerAuth";

class TripUnitItem extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  componentDidUpdate(preProps) {}

  onClickHandler(isCheck) {
    const { item, onAddUnitLogisticTrip, onDeleteUnitLogisticTrip, logisticSelectedTrip } = this.props;

    if (isCheck) {
      onDeleteUnitLogisticTrip(item.id, logisticSelectedTrip.id);
    } else {
      onAddUnitLogisticTrip({ id: item.id, title: item.unit.title, registerNumber: item.unit.registerNumber }, logisticSelectedTrip.id);
    }
  }

  render() {
    const { item, logisticSelectedTrip, data } = this.props;

    if (logisticSelectedTrip === null) return null;

    const getStatusStyles = () => {
      switch (item.unit.inActive ? "inActive" : getCarsTypeName(item.status.id)) {
        case "noData":
          return styles.container_carNumber_noData;
        case "inMove":
          return styles.container_carNumber_inMove;
        case "parking":
          return styles.container_carNumber_parking;
        case "inActive":
          return styles.container_carNumber_inActive;
        default:
          return null;
      }
    };

    const isCheck = logisticSelectedTrip.unit !== null && logisticSelectedTrip.unit.id === item.id;

    const addPermission = data.permissions.includes(32001);
    const deletePermission = data.permissions.includes(32001);

    const isViewButton = addPermission && deletePermission;

    return (
      <div className={styles.carsListItemWrapper}>
        <div className={styles.container_carsListItemWrapper}>
          <div className={styles.carsListItem}>
            <TooltipWrapper title={item.status.title} position="right">
              <div className={getStatusStyles()}>
                <span className={styles.title}>{item.number}</span>
              </div>
            </TooltipWrapper>

            <div className={styles.carsListItemInner}>
              <div className={styles.container_carContent}>
                <div className={styles.container_name}>
                  <div>{item.unit.title}</div>

                  <div>{item.unit.registerNumber}</div>
                </div>
              </div>

              {isViewButton ? (
                <div
                  className={styles.container_params}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onClickHandler(isCheck);
                  }}
                >
                  <TooltipWrapper
                    title={
                      isCheck
                        ? `Убрать ${item.unit.title} ${item.unit.registerNumber}`
                        : `Назначить на рейс ${item.unit.title} ${item.unit.registerNumber}`
                    }
                    position="top"
                  >
                    {isCheck ? (
                      <div className={styles.container_itemChecked}>
                        <CheckCircleIcon fontSize="small" />
                      </div>
                    ) : (
                      <div className={styles.container_itemUnchecked}>
                        <CheckCircleOutlineIcon fontSize="small" />
                      </div>
                    )}
                  </TooltipWrapper>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAuth(withLogisticTrips(withUnits(React.memo(TripUnitItem))));
